import AlertModal from "../AlertModal";
import { useTranslation } from "react-i18next";

const BankDetailsMissingModal = ({ open, onClose, onActionClick }) => {
  const { t } = useTranslation("bank-details-missing");

  return (
    <AlertModal
      {...{
        open,
        onClose,
        onActionClick,
        title: t("title"),
        description: t("description"),
        actionBtnText: t("action_button"),
      }}
    />
  );
};

export default BankDetailsMissingModal;
